import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ChainedBackend from "i18next-chained-backend";
import Backend from "i18next-http-backend";
import LocalStorageBackend from "i18next-localstorage-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import awsmobile from "../aws-exports";

i18n
  .use(ChainedBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(
    {
      load: "languageOnly",
      fallbackLng: "en",
      preload: ["en"],
      ns: [
        "authentication",
        "common",
        "conversations",
        "interests",
        "onboarding",
        "options",
        "permissions",
        "purchase",
        "products",
        "signIn",
        "signUp",
        "team",
        "translations",
        "user",
      ],
      backend: {
        backends: [LocalStorageBackend, Backend],
        backendOptions: [
          {
            expirationTime: 1 * 24 * 60 * 60 * 1000, // 1 day
          },
          {
            loadPath: `https://${
              awsmobile.aws_user_files_s3_bucket
            }.s3.amazonaws.com/translations/{{lng}}/{{ns}}.json?cb=${new Date().getTime()}`,
            crossDomain: true,
          },
        ],
      },
      cache: ["localStorage"],
      debug: false,
      saveMissing: false,
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
      react: {
        useSuspense: true,
      },
    },
    (err, t) => {
      if (err) {
        return console.error("err i18n", err);
      } else {
      }
    }
  );

export { i18n };
